import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from "./Customer.module.css";
import {
    Row,
    Col,
    Form,
    Button,
    Tab,
    Table,
    InputGroup,
    Breadcrumb,
} from "react-bootstrap";
import CustomerTax from "./CustomerTax";
import CustomerData from "./CustomerData";
import RegisterCustomerPayment2 from "./RegisterCustomerPayment2";
import AccountChecking from "./AccountChecking";
import NavStep2 from "./NavStep2";
import ServicePayment from "./ServicePayment";
import { useLocation } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import UtilClass from "api_ref/UtilClass";
import { ToastError,ToastSuccess } from "components/MyControl";

export default function PayTransactionDetail() {
    const param = useParams();
    const quontation_number = param.id;

    const api = new ApiConection();
    const utilcls = new UtilClass();

    const customer = utilcls.getSessionStorage('_dcaas_8089');
    const navigate = useNavigate();

    const [accountingFilePath,setAccountingFilePath] = useState(undefined); 
    const [validated, setValidated] = useState(false);
    const [dataPic, setDataPic] = useState({
        files: undefined,
        paid_file_slip: undefined,
        // path: `audit/${state.data?.register_number}/${state.data?.quontation_number}`,
        // ref_code: state.data?.quontation_number,
    });

    const [fileId, setFileId] = useState({
        id: 1,
    });

    const [data, setData] = useState(undefined);
    const [step, setStep] = useState(undefined);

    const [dataAudit, setDataAudit] = useState({
        path: `audit/${data?.register_number}/${data?.quontation_number}`,
        ref_code: data?.quontation_number,
    });

    //not sure wait to ask p'eak later about name: dataPic.files or dataPic.paid_file_slip
    const [objPic, setObjPic] = useState({
        name: dataPic.files,
        id: fileId.id,
        paid_file_slip: undefined,
    });
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [showToastError, setShowToastError] = useState(false);

    const handleBreadcrumbClick = (e) => {
        navigate('/sales/quontation-list');
    };
    const getSlipFile = async (id) => {
        if (id !== null && id !== undefined) {
            return await api.getFile(`api/file/${id}/preview`);
        } else {
            return undefined;
        }
    }

    const getQuonData = async () => {
        const response = await api.getData(`api/quontation/${quontation_number}`);
        if (response.status === true) {
            setData(response.data);
            setStep(response.data.audit_status_id);
            setAccountingFilePath(`accounting/${response.data?.register_number}/${response.data?.quontation_number}`)
        } else {
            return;
        }
    };

    const getAuditData = async () => {
        const response = await api.getData(`api/Accounts/register/${data?.register_number}/quontation/${quontation_number}`);
        if (response.status === true) {
            let data_account = response.data;
            data_account.audit_status_id = data.audit_status_id;
            setDataAudit(data_account);

            const response_invoice = await getSlipFile(data_account.issued_invoice_file_id);
            if(response_invoice !== undefined){
                handleChangeData({target:{name:'issued_invoice_file_image',value:URL.createObjectURL(response_invoice)}})
            }
            const response_payment = await getSlipFile(data_account.payment_verified_file_id);
            if(response_payment !== undefined){
                handleChangeData({target:{name:'payment_verified_file_image',value:URL.createObjectURL(response_payment)}})
            }
            const response_receipt = await getSlipFile(data_account.issued_receipt_file_id);
            if(response_receipt !== undefined){
                handleChangeData({target:{name:'issued_receipt_file_image',value:URL.createObjectURL(response_receipt)}})
            }
            const response_withhoding_tax = await getSlipFile(data_account.received_withholing_tax_file_id);
            if(response_withhoding_tax !== undefined){
                handleChangeData({target:{name:'received_withholing_tax_file_image',value:URL.createObjectURL(response_withhoding_tax)}})
            }
        } else {
            setDataAudit({
                audit_status_id: data.audit_status_id,

                is_issued_invoice: false,
                issued_invoice_memo: '',
                issued_invoice_file_id: null,

                is_payment_verified: false,
                payment_verified_memo: '',
                payment_verified_file_id: null,

                is_issued_receipt: false,
                issued_receipt_memo: '',
                issued_receipt_file_id: null,

                is_received_withholing_tax: false,
                received_withholing_tax_memo: '',
                received_withholing_tax_file_id: null

            });
        }


    };

    useEffect(() => {
        getQuonData();
    }, []);

    useEffect(() => {
        if (data !== undefined)
            getAuditData();
    }, [data]);

    const handleChangeData = (event) => {
        const { name, value, type, checked, files } = event.target;

        if (event.target.setCustomValidity) {
            event.target.setCustomValidity("");
        }

        if (type === "file") {
            setDataAudit((prevData) => {
                return { ...prevData, [name]: files ? files[0] : undefined || value };
            });
        } else if (type === "checkbox") {
            setDataAudit((prevData) => {
                return { ...prevData, [name]: checked };
            });
        } else {
            setDataAudit((prevData) => {
                return { ...prevData, [name]: value };
            });
        }
    };

    const headerTitle = () => {
        if (data?.audit_status_id === 1) {
            return <label>รายการรอจัดทำใบแจ้งหนี้</label>;
        } else if (data?.audit_status_id === 2) {
            return <label>รายการรอตรวจสอบ</label>;
        } else if (data?.audit_status_id === 3) {
            return <label>รายการเอกสารหัก ณ ที่จ่าย</label>;
        } else if (data?.audit_status_id === 4) {
            return <label>รายการเสร็จสมบูรณ์</label>;
        }
    };

    const handleThisSubmit = async (event) => {
        const registerName = data?.register_number;
        //refresh page
        event.preventDefault();

        //const form = event.target.closest('form');

        setLoading(true);

        let issued_invoice_file_id = null;
        let payment_verified_file_id = null;
        let issued_receipt_file_id = null;
        let received_withholing_tax_file_id = null;

        //debugger;
        if( (dataAudit.issued_invoice_file !== undefined && dataAudit.issued_invoice_file !== null) && dataAudit?.issued_invoice_file_id === null){
            let formdata = new FormData();
                formdata.append("files", dataAudit.issued_invoice_file);
                formdata.append("path", accountingFilePath);
                formdata.append("ref_code", data.register_number);

                const responseUpload = await api.postFile(
                    `api/file/upload/paymentslip`,
                    formdata
                );

                if (responseUpload.status === true) {
                    handleChangeData({ target: { name: 'issued_invoice_file_id', value: responseUpload.data.id } });
                    handleChangeData({ target: { name: 'issued_invoice_file_image', value: URL.createObjectURL(dataAudit.issued_invoice_file) } });
                    issued_invoice_file_id = responseUpload.data.id;
                } else {
                    setAlert('ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง !!');
                    setLoading(false);
                    return;
                }

        }else if(dataAudit?.issued_invoice_file_image !== undefined && dataAudit.issued_invoice_file_image !== null){
            issued_invoice_file_id = dataAudit?.issued_invoice_file_id;
        }

        if( (dataAudit.payment_verified_file !== undefined && dataAudit.payment_verified_file !== null) &&  dataAudit?.payment_verified_file_id === null){
            let formdata = new FormData();
                formdata.append("files", dataAudit.payment_verified_file);
                formdata.append("path", accountingFilePath);
                formdata.append("ref_code", data.register_number);

                const responseUpload = await api.postFile(
                    `api/file/upload/paymentslip`,
                    formdata
                );

                if (responseUpload.status === true) {
                    handleChangeData({ target: { name: 'payment_verified_file_id', value: responseUpload.data.id } });
                    handleChangeData({ target: { name: 'payment_verified_file_image', value: URL.createObjectURL(dataAudit.payment_verified_file) } });
                    payment_verified_file_id = responseUpload.data.id;
                } else {
                    setAlert('ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง !!');
                    setLoading(false);
                    return;
                }
        }else if(dataAudit?.payment_verified_file_image !== undefined && dataAudit.payment_verified_file_image !== null){
            payment_verified_file_id = dataAudit?.payment_verified_file_id;
        }

        if((dataAudit.issued_receipt_file !== undefined && dataAudit.issued_receipt_file !== null) && dataAudit?.issued_receipt_file_id === null){
            let formdata = new FormData();
                formdata.append("files", dataAudit.issued_receipt_file);
                formdata.append("path", accountingFilePath);
                formdata.append("ref_code", data.register_number);

                const responseUpload = await api.postFile(
                    `api/file/upload/paymentslip`,
                    formdata
                );

                if (responseUpload.status === true) {
                    handleChangeData({ target: { name: 'issued_receipt_file_id', value: responseUpload.data.id } });
                    handleChangeData({ target: { name: 'issued_receipt_file_image', value: URL.createObjectURL(dataAudit.issued_receipt_file) } });
                    issued_receipt_file_id = responseUpload.data.id;
                } else {
                    setAlert('ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง !!');
                    setLoading(false);
                    return;
                }
        }else if(dataAudit?.issued_receipt_file_image !== undefined && dataAudit.issued_receipt_file_image !== null){
            issued_receipt_file_id = dataAudit?.issued_receipt_file_id;
        }

        if((dataAudit.received_withholing_tax_file !== undefined && dataAudit.received_withholing_tax_file !== null) && dataAudit?.received_withholing_tax_file_id === null){
            let formdata = new FormData();
                formdata.append("files", dataAudit.received_withholing_tax_file);
                formdata.append("path", accountingFilePath);
                formdata.append("ref_code", data.register_number);

                const responseUpload = await api.postFile(
                    `api/file/upload/paymentslip`,
                    formdata
                );

                if (responseUpload.status === true) {
                    handleChangeData({ target: { name: 'received_withholing_tax_file', value: responseUpload.data.id } });
                    handleChangeData({ target: { name: 'received_withholing_tax_file_image', value: URL.createObjectURL(dataAudit.received_withholing_tax_file) } });
                    received_withholing_tax_file_id = responseUpload.data.id;
                } else {
                    setAlert('ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง !!');
                    setLoading(false);
                    return;
                }
        }else if(dataAudit?.received_withholing_tax_file_image !== undefined && dataAudit.received_withholing_tax_file_image !== null){
            received_withholing_tax_file_id = dataAudit?.received_withholing_tax_file_id;
        }
        

        let objDataSubmit = {
            obj_issued_invoice: {
                is_issued_invoice: dataAudit.is_issued_invoice,
                issued_invoice_memo: dataAudit.issued_invoice_memo,
                issued_invoice_file_id: issued_invoice_file_id,
            },
            obj_payment_verified: {
                is_payment_verified: dataAudit.is_payment_verified,
                payment_verified_memo: dataAudit.payment_verified_memo,
                payment_verified_file_id: payment_verified_file_id,
            },
            obj_issued_receipt: {
                is_issued_receipt: dataAudit.is_issued_receipt,
                issued_receipt_memo: dataAudit.issued_receipt_memo,
                issued_receipt_file_id: issued_receipt_file_id,
            },
            obj_received_withholding_tax: {
                is_received_withholing_tax: dataAudit.is_received_withholing_tax,
                received_withholing_tax_memo: dataAudit.received_withholing_tax_memo,
                received_withholing_tax_file_id: received_withholing_tax_file_id,
            },
        };

        objDataSubmit.payment_status_id = null;
        if(parseInt(dataAudit?.payment_status_id) !== parseInt(data?.payment_status_id)){
            objDataSubmit.payment_status_id = dataAudit?.payment_status_id;
        }

        if (event.target.value === 'btnChangeStatus') {
            objDataSubmit.audit_status_id = dataAudit.audit_status_id;
        }

        //issued_invoice_file_id ต้องเอามาจาก api id ที่ return จาก api save file อีกที

        const responseData = await api.postData(
            `api/accounts/register/${registerName}/quontation/${quontation_number}`,
            objDataSubmit
        );

        //---------This session for Save File------------
        /*debugger;
        let formdata = new FormData();
        formdata.append("files", dataSubmit.paid_file_slip);
        formdata.append("path", dataSubmit.path);
        formdata.append("ref_code", dataSubmit.ref_code);
        const response = await api.postFile(
          `api/file/upload/paymentslip`,
          formdata
        );
        if (response.status === true) {
          // setFileId(response.data.id)
          handleChangeData({
            target: {
              name: "issued_invoice_file_id",
              value: response.data.id,
            },
          });
        }*/
        //console.log("data-Id",fileId);
        if (responseData.status === true) {
            setShowSuccess(true);

            if (parseInt(objDataSubmit.audit_status_id) !== step) {
                switch (parseInt(objDataSubmit.audit_status_id)) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        navigate(`/account/quontation-list`);
                        break;
                }
            }
        }
        setLoading(false);
    };

    // useEffect(() => {
    //   if (dataPic.path !== '' && dataPic.ref_code !== '') {
    //     handleThisSubmit();
    //   }
    // }, [dataPic.path, dataPic.ref_code]);
    //console.log("dataSubmit",dataSubmit);

    return (
        <Layout4Admin1 className=''>
            <div className={Css.Block_Transparent + " pb-0"}>
            <Breadcrumb>
                <Breadcrumb.Item onClick={handleBreadcrumbClick}>เซลล์/ มาร์เก็ตติ้ง</Breadcrumb.Item>
                <Breadcrumb.Item onClick={handleBreadcrumbClick}>รายการทั้งหมด</Breadcrumb.Item>
                <Breadcrumb.Item active>{quontation_number}</Breadcrumb.Item>
            </Breadcrumb>
            </div>
            <div className={Css.border_layout + " position-relative shadow"}>
                <div className="">
                    <span className={`mb-2 ${Css.dis} ${Css.colorh5}`}>
                        {headerTitle()}
                        <i className="fa-solid fa-angle-right mx-3"></i>
                        <label> {quontation_number}</label>
                    </span>
                    <div className={Css.brd}></div>
                    {
                        data &&
                        <>
                            <NavStep2
                                stepPage={step}
                                quontation_number={quontation_number}
                            />
                            <Row className="mt-3">
                                <Col xs={5}>
                                    <Row className="mb-2">
                                        <ServicePayment stepPage={step} dataSubmit={dataAudit} data={data} disabled={true} onChangeData={(event) => handleChangeData(event)}/>
                                    </Row>
                                    <Row className="mb-2">
                                        <RegisterCustomerPayment2 stepPage={step} data={data} disabled={true} />
                                    </Row>
                                    <Row className="mb-2">
                                        <CustomerTax stepPage={step} data={data} disabled={true} />
                                    </Row>
                                    <Row>
                                        <CustomerData stepPage={step} data={data} disabled={true} />
                                    </Row>
                                </Col>
                                <Col>
                                    <Form
                                        encType="multipart/form-data"
                                        noValidate
                                        validated={validated}
                                        onSubmit={(event) => handleThisSubmit(event)}
                                    >
                                        <AccountChecking
                                            data={data}
                                            disabled={true}
                                            stepPage={step}
                                            dataPic={dataPic}
                                            onChangeData={(event) => handleChangeData(event)}
                                            objPic={objPic}
                                            dataSubmit={dataAudit}
                                            onSubmit={handleThisSubmit}
                                            loading={loading}
                                            alert={alert}
                                            setAlert={setAlert}
                                        />
                                    </Form>
                                </Col>
                            </Row>
                        </>
                    }
                    {
                        data === undefined &&
                        <>
                            <p className="placeholder-glow">
                                <span className="placeholder rounded col-12 mb-3" style={{ height: '60px' }}></span>
                                <Row>
                                    <Col>
                                        <div className="border rounded p-4">
                                            <span className="placeholder rounded col-12 mb-3  bg-primary" ></span>
                                            <span className="placeholder rounded col-7" ></span>
                                            <span className="placeholder rounded col-5" ></span>
                                            <span className="placeholder rounded col-8" ></span>
                                            <span className="placeholder rounded col-4" ></span>
                                            <span className="placeholder rounded col-5" ></span>
                                            <span className="placeholder rounded col-7" ></span>
                                            <span className="placeholder rounded col-3" ></span>
                                            <span className="placeholder rounded col-2" ></span>
                                            <span className="placeholder rounded col-8" ></span>

                                        </div>

                                    </Col>
                                    <Col>
                                        <div className="border rounded p-4">
                                            <span className="placeholder rounded col-12 mb-3  bg-primary" ></span>
                                            <span className="placeholder rounded col-7" ></span>
                                            <span className="placeholder rounded col-3" ></span>
                                            <span className="placeholder rounded col-8" ></span>
                                            <span className="placeholder rounded col-4" ></span>
                                            <span className="placeholder rounded col-5" ></span>
                                            <span className="placeholder rounded col-7" ></span>
                                            <span className="placeholder rounded col-3" ></span>
                                            <span className="placeholder rounded col-2" ></span>
                                            <span className="placeholder rounded col-8" ></span>

                                        </div>
                                    </Col>
                                </Row>
                            </p>
                        </>
                    }
                    {
                        loading &&
                        <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5, top: 0, left: 0 }}>
                            <div className="fixed-center">
                                <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            
            <ToastSuccess show={showSuccess} closeFc={(_) => setShowSuccess(false)} message="บันทึกแล้ว!!" />
            <ToastError show={showToastError} closeFc={setShowToastError} message={'เกิดข้อผิดพลาด!!'} />
        </Layout4Admin1>
    );
}